import { ADMIN } from 'src/Actions/Admin/types';

export const initialState = {
  emailId: '',
  fieldValue: {},
  formError: {},
  isErrorDisplay: false,
  showToast: false,
  userValidationRes: null,
  isLoading: false,
  addUserSuccessRes: null,
  userRequest: null,
  updateUserSuccessRes: null,
  userDetails: null,
  userDetailsErr: null,
  toastMessage: '',
  isEmailVerifying: false,
  isSingleAccount: false,
  progressBuffer: false,
  accrediting: [],
  languages: [],
  regex: null
};

const adminReducer = (state = initialState, action) => {  //NOSONAR

  switch (action.type) {
    case ADMIN.DISPLAY_TOAST: {
      let { val } = action;
      return {
        ...state,
        showToast: val,
      };
    }
    case ADMIN.UPDATE_FIELD_VALUE: {
      const { fieldValue: newValue } = action;
      return {
        ...state,
        fieldValue: { ...state.fieldValue, ...newValue },
      };
    }
    case ADMIN.UPDATE_ERROR: {
      const { errorValue } = action;
      return {
        ...state,
        formError: setFormError(state.formError, errorValue),
        isErrorDisplay: setErrorDisplay(state.formError),
      };
    }
    case ADMIN.RESET_VALUES: {
      return {
        ...state,
        formError: {},
        isErrorDisplay: false,
        fieldValue: {},
      };
    }
    case ADMIN.VERIFY_EMAIL: {
      let { activationKey, persona, email } = action;
      return {
        ...state,
        isEmailVerifying: true,
        activationKey,
        persona,
        email,
        userValidationRes: null,
      };
    }
    case ADMIN.VERIFY_EMAIL_SUCCESS: {
      let { res } = action;
      let formattedAccrediting = res.accreditingTypesList?.map((item) => {
        return {
            key: item,
            text: item
        }
    });
      return {
        ...state,
        isEmailVerifying: false,
        userValidationRes: res,
        accrediting: formattedAccrediting ? formattedAccrediting : []
      };
    }
    case ADMIN.VERIFY_EMAIL_FAILURE: {
      return {
        ...state,
        isEmailVerifying: false,
      };
    }
    case ADMIN.PROGRESS_ON: {
      return {
        ...state,
        progressBuffer: true,
      };
    }
    case ADMIN.PROGRESS_OFF: {
      let { res } = action;
      return {
        ...state,
        progressBuffer: false,
        showToast: true,
        toastMessage: res,
        isLoading: false,
      };
    }
    case ADMIN.ADD_TEAM_MEMBER:
    case ADMIN.ADD_USER: {
      let { userRequest } = action;
      return {
        ...state,
        userRequest,
        toastMessage: '',
        isLoading: true,
      };
    }
    case ADMIN.ADD_USER_SUCCESS: {
      let { res } = action;
      return {
        ...state,
        showToast: true,
        toastMessage: res,
        isLoading: false,
      };
    }
    case ADMIN.UPDATE_USER: {
      let { activationKey, isValid, email, searchKey } = action;
      return {
        ...state,
        activationKey,
        isValid,
        email,
        searchKey,
        toastMessage: '',
      };
    }
    case ADMIN.UPDATE_USER_SUCCESS: {
      let { res } = action;
      return {
        ...state,
        showToast: true,
        toastMessage: res,
      };
    }

    case ADMIN.GET_USER_DETAILS: {
      let { emailId } = action;
      return {
        ...state,
        emailId,
      };
    }
    case ADMIN.GET_USER_DETAILS_SUCCESS: {
      let { response } = action;
      return {
        ...state,
        userDetails: response,
      };
    }
    case ADMIN.GET_USER_DETAILS_FAILURE: {
      let { error } = action;
      return {
        ...state,
        userDetailsErr: error,
      };
    }
    case ADMIN.IS_SINGLE_ACCOUNT: {
      let { isSingleAccount } = action;
      return {
        ...state,
        isSingleAccount,
      };
    }
    case ADMIN.GET_LANGUAGE_DETAILS:{
      return {
        ...state,
        isLoading: true
      }
    }
    case ADMIN.GET_LANGUAGE_DETAILS_SUCCESS:{
      let { response } = action;
      let formattedLanguage = sortLanguage(response).map((item) => {return{key: item.language, text: item.language}});      
      return{
        ...state,
        languages: formattedLanguage ? formattedLanguage : [],
        fieldValue: {...state.fieldValue, language: formattedLanguage.find((lang) =>  lang.key === 'English').key},
        isLoading: false,
      }
    }
    case ADMIN.GET_LANGUAGE_DETAILS_FAILURE:{
      const { errorValue } = action;
      return {
        ...state,
        formError: setFormError(state.formError, errorValue),
        isErrorDisplay: setErrorDisplay(state.formError),
        isLoading: false,
      }
    }

    case ADMIN.FETCH_REGEX_SUCCESS:
      return { ...state, regex: action.response };
    case ADMIN.FETCH_REGEX_FAILURE:
      return { ...state, error: action.error };

    default:
      return state;
  }
};

const setFormError = (formError, errorObj) => {
  for (let i in errorObj) {
    if (errorObj[i] === '') {
      if (formError[i]) delete formError[i];
    } else {
      formError = { ...formError, ...errorObj };
    }
  }
  return formError;
};

const setErrorDisplay = (formError) => {
  let isErrorDisplay = false;
  if (Object.entries(formError).length > 0) {
    isErrorDisplay = true;
  }
  return isErrorDisplay;
};

const sortLanguage = (response) =>{
  response.sort((a, b) => {
    let languageFirst = a.language.toLowerCase(),
    languageSecond = b.language.toLowerCase();

    if (languageFirst < languageSecond) {
        return -1;
    }
    if (languageFirst > languageSecond) {
        return 1;
    }
    return 0;
  });
  return response;
}
export default adminReducer;
